import React from "react"
import {
    Stack,
    VStack,
    HStack,
    Link,
    Box,
    Text
  } from '@chakra-ui/react';

import { Link as GatsbyLink } from "gatsby"
import { EmailIcon, ExternalLinkIcon } from '@chakra-ui/icons'

import SecondaryButton from "../atoms/secondaryButton.tsx"

const offerMobile: React.FC = () => {
    return (
    <VStack w={'full'} maxW={'1140px'} spacing={4} py={7} px={5} bgColor={'blue'} color={'white'} position={'relative'} zIndex={'20'}>
        <Text fontWeight={'bold'} fontSize={{base: '2xl', md: '4xl'}}>お問い合わせ</Text>
        <SecondaryButton ButtonName={'お問い合わせフォーム'} url={'/contact'} />
        <Stack mt={'1rem'}>
            <Box>
                <Text fontWeight={'bold'}>本社</Text>
                <HStack>
                    <Link href={'tel:048-928-1001'}>
                        <Text fontWeight={'bold'} fontSize={'2xl'}>048-928-1001</Text>
                    </Link>
                    <Text fontWeight={'bold'} fontSize={'md'}>(代表)</Text>
                </HStack>
            </Box>
            <Box>
                <Text fontWeight={'bold'}>大利根工場</Text>
                <HStack>
                <Link href={'tel:0480-72-4187'}>
                    <Text fontWeight={'bold'} fontSize={'2xl'}>0480-72-4187</Text>
                </Link>
                </HStack>
            </Box>
            <Box>
                <Text fontWeight={'bold'}>茨城工場</Text>
                <HStack>
                <Link href={'tel:0299-58-1155'}>
                    <Text fontWeight={'bold'} fontSize={'2xl'}>0299-58-1155</Text>
                </Link>
                </HStack>
            </Box>
            <Box>
                <Text fontWeight={'bold'}>トータルパッケージソリューション部</Text>
                <HStack>
                <Link href={'tel:048-928-1008'}>
                    <Text fontWeight={'bold'} fontSize={'2xl'}>048-928-1008</Text>
                </Link>
                <Text fontWeight={'bold'} fontSize={'md'}>(直通)</Text>
                </HStack>
            </Box>
        </Stack>
    </VStack>
  )
}
export default offerMobile